<template>
    <div class="search-content">
      <div class="search-head">
        <form action=".">
          <el-input v-model="searchText" type="search" class="home-head-seach" placeholder="搜索内容"
            prefix-icon="el-icon-search" autocomplete="off" @keyup.enter="searchTextSubmit" clearable></el-input>
          <input type="text" style="display: none;" />
        </form>
      </div>
      <div class="teach-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled" infinite-scroll-distance="20"
        infinite-scroll-immediate="false">
        <div class="teach-each" v-for="(item, value) in rows" :key="value" @click="toTeachDetail(item)">
          <template v-if="item.image != null && item.image != ''">
            <img :src=item.image class="teach-each-img" />
          </template>
          <template v-else>
            <img src="../assets/image/teaching-img.png" class="teach-each-img" />
          </template>
          <div class="teach-info">
            <div class="teach-name"> {{ item.name }}</div>
            <div class="teach-price red">¥ {{ item.orderPrice }}</div>
          </div>
        </div>
        <!-- 下拉加载时候加loading旋转动效 -->
        <div v-if="loading" style="margin-top:10px;" class="loading">
          <span>loding...</span>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { listPurchasedTeachingGather } from '@/api/common'   //路径
  export default {
    name: 'PaidTeachPage',
    props: ['id'],
    data() {
      return {
        searchText: '',
        merchantId: '',
        rows: [],
        pageNum: 1,
        pageSize: 8,
        loading: false,
        pageIndex: 1,
        categoryVos: [],
        title: '',
        pages: ''
      }
    },
    created() {
      this.merchantId = this.id;
      this.getTeachingGatherList();
    },
    //计算
    computed: {
      noMore() {
        //当起始页数大于总页数时停止加载
        return this.pageIndex >= this.pages;
      },
      disabled() {
        return this.loading || this.noMore;
      }
    },
    methods: {
      getTeachingGatherList() {
        let params = {
          'contentText': this.searchText,
          'merchantId': this.merchantId,
          'pageSize': this.pageSize,
          'pageNum': this.pageNum,
          'orderByColumn': 'tgo.pay_time desc,tgo.id',
          'isAsc': 'desc'
        };
        listPurchasedTeachingGather(params).then((res) => {
          this.rows = this.rows.concat(res.rows);
          this.pages = Math.ceil(res.total / this.pageSize);
        })
      },
      load() {
        //滑到底部时进行加载
        this.loading = true;
        let params = {
          'contentText': this.searchText,
          'merchantId': this.merchantId,
          'pageSize': this.pageSize,
          'pageNum': this.pageIndex + 1,
          'orderByColumn': 'tgo.pay_time desc,tgo.id',
          'isAsc': 'desc'
        }
        listPurchasedTeachingGather(params).then((res) => {
          this.rows = this.rows.concat(res.rows);
          this.pageIndex++
          this.loading = false;
        })
      },
      searchTextSubmit() {
        this.rows = [];
        this.pageIndex = 1;
        this.pages = '';
        this.loading = false;
        this.getTeachingGatherList();
      },
      changeCategory(id) {
        this.categoryId = id;
        this.searchTextSubmit();
      },
      toTeachDetail(item) {
        this.$router.push({ path: '/teaching/' + this.merchantId, query: { 
          teachingId: item.id,
        }});
      }
    }
  }
  </script>
  
  <style scoped>
  .search-content {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
  
  .search-head {
    padding: 10px 15px;
  }
  
  .home-head-seach {
    margin: 0;
    height: 40px !important;
    line-height: 40px;
    border-radius: 18px;
    overflow: hidden;
  }
  
  .home-head-seach :deep(.el-input__inner) {
    font-size: 14px;
    color: #333333;
    border: 0;
    border-radius: 18px;
    background: #F2F2F2;
    outline: none;
  }
  
  ::v-deep input[type="search"]::-webkit-search-decoration,
  ::v-deep input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
    appearance: none;
    display: none;
  }
  
  .teach-list {
    flex: 1;
    padding: 0 15px;
    overflow-y: auto;
  }
  
  .teach-each {
    display: flex;
    margin-bottom: 15px;
    min-height: 90px
  }
  
  .teach-each-img {
    margin-right: 10px;
    width: 142px;
    height: 90px;
    object-fit: cover;
    border-radius: 5px;
  }
  
  /* 加载时候转圈的动效 */
  .loading {
    text-align: center;
  }
  
  .loading span {
    display: inline-block;
    font-size: 14px;
    color: #666;
  }
  
  .teach-info {
    flex: 1;
    text-align: left;
    overflow: hidden;
  }
  
  .teach-name {
    margin-bottom: 10px;
    font-family: PingFangHK-Regular;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    font-weight: 400;
  }
  
  .teach-price {
    font-family: PingFangHK-Regular;
    font-size: 14px;
    font-weight: 400;
  }
  
  .teach-price.green {
    color: #13D275;
  }
  
  .teach-price.red {
    color: #F11515;
  }
  
  .category-list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
  }
  
  .category-each {
    margin: 0 10px 10px 0;
    min-width: 72px;
    height: 25px;
    line-height: 25px;
    text-align: center;
    background: #F6F4F4;
    font-family: PingFangHK-Regular;
    font-size: 12px;
    color: #999999;
    font-weight: 400;
    border-radius: 29.5px;
  }
  
  .category-each.main {
    color: #FFFFFF;
    background: #0095D9;
  }
  </style>